export default __webpack_public_path__ + "static/media/dynamic.d271792c.svg";